import React from "react";
import { useAuth } from "providers/AuthProvider";
import { DossierList } from "components/DossierList";
import Main from "components/Main";
import Search from "components/Search";
import { useSearchFilters } from "hooks/useSearchFilters";

export default function Dossiers() {
  const { isManager, isPartner, isCustomer } = useAuth();

  const { setSearch, getFilters } = useSearchFilters(isCustomer);

  return (
    <Main
      title={isCustomer ? "Mes projets" : "Mes dossiers"}
      header={
        <Search
          setSearch={setSearch}
          placeholder={
            isManager || isPartner
              ? "Bénéficiaire, référence, chantier ou SIRET…"
              : "Recherche opération ou chantier…"
          }
        />
      }
    >
      <DossierList setFilters={getFilters} />
    </Main>
  );
}

Dossiers.defaultProps = {};

Dossiers.propTypes = {};
